import React from "react";

const FilterRange = ({
                         id = "customRange",
                         min = 1,
                         max = 40,
                         step = 1,
                         value = null,
                         onChange = () => {},
                         leftLabel = "1miles",
                         rightLabel = "40miles"
                     }) => {
    const progress = value !== null
        ? ((value - min) * 100) / (max - min)
        : 0;

    return (
        <div className="mb-3">
            <div className="range-label d-flex justify-content-between px-1 mb-0">
                <label htmlFor={id} className="range-label text-black-50">
                    {leftLabel}
                </label>
                <label htmlFor={id} className="range-label text-black-50">
                    {rightLabel}
                </label>
            </div>
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value ?? 0}
                onChange={onChange}
                className="custom-range w-100"
                id={id}
                style={{
                    background: `linear-gradient(to right, #0d6efd ${progress}%, Gainsboro 0%)`
                }}
            />
        </div>
    );
};

export default FilterRange;